/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const PenIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      className="with_stroke"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2857 4.5L13.5 7.71429"
        stroke={color}
        strokeWidth="1.54286"
        strokeMiterlimit={10}
      />
      <path
        d="M7.07144 14.1428L2.57144 15.4285L3.85716 10.9285L11.8376 2.94809C12.3397 2.44602 13.1535 2.44602 13.6556 2.94809L15.0519 4.34437C15.5539 4.84644 15.5539 5.6603 15.0519 6.16237L7.07144 14.1428Z"
        stroke={color}
        strokeWidth="1.54286"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
    </svg>
  );
};
